import { tokens } from "../theme";

/**
 * The status colour scale shared by the attendance register and the leave
 * dashboard, so a given meaning looks the same wherever it appears.
 *
 * Extends the StatusChip tones in component/listing.js with "violet", which
 * these surfaces need to keep missing-punch distinct from on-leave. It draws
 * on the sixth categorical chart colour rather than an off-palette purple.
 *
 * Tints and their text colours are the brand book's picked pairs: the tint is
 * the background, the text variant is the label on it, and the solid is for
 * icons and borders.
 */
const VIOLET = "#7A5B8E";
// The violet tint, mixed once at 12% over card rather than left as a wash —
// a translucent fill over the blush page goes muddy, which is why every other
// tint here is a picked value.
const VIOLET_TINT = "#F0ECF2";

export const TONE_COLORS = {
  success: { fg: tokens.successText, bg: tokens.successTint },
  warning: { fg: tokens.warningText, bg: tokens.warningTint },
  danger: { fg: tokens.danger, bg: tokens.dangerTint },
  info: { fg: tokens.infoText, bg: tokens.infoTint },
  violet: { fg: VIOLET, bg: VIOLET_TINT },
  muted: { fg: tokens.pendingText, bg: tokens.pendingTint },
  // Not a status: a figure that is simply a fact, carrying no colour of its own.
  // Present so a caller can ask for "no tone" without falling through to muted.
  ink: { fg: tokens.text, bg: tokens.surfaceSubtle },
};

export const toneColors = (tone) => TONE_COLORS[tone] || TONE_COLORS.muted;
